export default "__VITE_ASSET__OZXirJmH__"